import { merge } from '../../helper';

import addClass from '../../general/class/addClass';
import hasClass from '../../general/class/hasClass';
import removeClass from '../../general/class/removeClass';

// ----------------------------------------------------------------------------

export type TypeToggle = {
    merge?: any;
    enabled: string;
    disabled: string;
    value?: boolean;
};

// ----------------------------------------------------------------------------

function toggle(element: HTMLElement, config?: TypeToggle): boolean {
    // Default Config
    const defConfig: TypeToggle = {
        enabled: 'fa-solid fa-check',
        disabled: 'fa-solid fa-times',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    if (typeof defConfig.value != 'boolean') {
        defConfig.value = hasClass(element, defConfig.disabled);
    }

    //
    removeClass(element, defConfig.value ? defConfig.disabled : defConfig.enabled);
    //
    addClass(element, defConfig.value ? defConfig.enabled : defConfig.disabled);

    // ------------------------------------------------------------------------

    //
    return defConfig.value;
}

// ----------------------------------------------------------------------------

export { toggle };
